import React from "react";
import ReactDOM from "react-dom/client";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";

import "./index.css";
import "../src/styles/fonts.css";

import Layout from "./pages/layout/layout";
import { QueryClient, QueryClientProvider } from "react-query";
import { MsalProvider } from "@azure/msal-react";
import { msalApp } from "./constants/auth.constant";
import { Login } from "./pages/login/login";
import Agreement from "./pages/agreement/agreement";
import GptChat from "./pages/gpt-chat/chat";
import RoleGuard from "./routes/role-guard";
import UserManager from "./pages/admin/user-manager/user-manager";
import FeedbackManager from "./pages/admin/feedback-manager/feedback-manager";
import CorpusManager from "./pages/admin/corpus-manager/corpus-manager";
import ChatMetrics from "./pages/admin/chat-metrics/chat-metrics";
import OverallMonitor from "./pages/admin/monitor-evaluate/OverallMonitor";
import LiveMonitor from "./pages/admin/monitor-evaluate/LiveMonitor";
import Unauthorized from "./pages/unauthorized/unauthorized";

initializeIcons();

export default function App() {
  const queryClient = new QueryClient();

  return (
    <MsalProvider instance={msalApp}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<Login />} />
            <Route path="/agreement" element={<Agreement />} />

            {/* Protected Area */}
            <Route element={<Layout />}>
              
              {/* Common Routes for User + Admin */}
              <Route element={<RoleGuard allowedRoles={["User"]} />}>
                <Route
                path="/"
                element={<Navigate to="/chat/chop-gpt" replace />}
                />
                <Route path="/chat/:type" element={<GptChat />} />
                <Route path="/chat/:type/:conversationId" element={<GptChat />} />
              </Route>

              {/* Admin-only Routes */}
              <Route element={<RoleGuard allowedRoles={["Admin"]} />}>
                <Route path="/admin">
                  <Route
                    index
                    element={<Navigate to="user-manager" replace />}
                  />

                  <Route path="user-manager" element={<UserManager />} />
                  <Route path="feedback-manager" element={<FeedbackManager />} />
                  <Route path="chat-metrics" element={<ChatMetrics />} />
                  <Route path="corpus-manager" element={<CorpusManager />} />
                  <Route path="monitor/overall-response" element={<OverallMonitor />} />
                  <Route path="monitor/live-response" element={<LiveMonitor />} />

                </Route>
              </Route>

              {/* Fallback */}
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route
                path="*"
                element={<Navigate to="/chat/chop-gpt" replace />}
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </MsalProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
